import styled from 'styled-components';
import { Form } from 'formik';

import colors from '../../../styles/colors';

export const Container = styled.div`
  background-color: white;
  width: 80%;
  height: 350px;
  border: 1px solid ${colors.lightgray};
`;

export const ContainerText = styled.div`
  padding-top: 80px;
  padding-bottom: 20px;
  width: 80%;
`;

export const Text = styled.h1`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  color: ${colors.blueEinstein};
  font-weight: 400;
  font-size: 20px;
`;

export const Titulo = styled.h1`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  color: ${colors.blueEinstein};
  font-weight: 400;
  font-size: 16px;
`;

export const ContainerForm = styled(Form)`
  padding: 40px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
`;

export const ButtonContainer = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  position: relative;
  top: 70px;
  right: 30px;
`;

export const ContainerError = styled.div`
  padding: 10px;
`;

export const InputError = styled.span`
  position: absolute;
  bottom: -15px;
  left: 13px;
  font-size: 12px;
  color: ${colors.danger};
  font-weight: 400;
`;

export const ContentForm = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: repeat(3, 1fr);
  grid-column-gap: 0px;
  grid-row-gap: 0px;
`;

export const ContentFormTwo = styled.div`
  position: relative;
  top: 48px;
  left: 55px;
`;

export const Space = styled.div`
  padding-top: 15px;
`;
